import React from 'react';
import About from './About';
import Research from './Research'

function HomePage() {
  return (
    <div>
      <About />
    </div>
  );
}

export default HomePage;